import React from "react";
import PropsTypes from "prop-types";

import { GlossaryComponent as Glossary } from "@learningblocks/storybook-components/lib/GlossaryComponent";
import { CloseButton } from "@learningblocks/shared-components/lib/CloseButton";
import { LogEvent } from "@learningblocks/shared-components";
import { GlossaryDispatch } from "../index";

import style from "./style.module.scss";

/**
 *  GlossaryWeb:
 *      Glossary Content to be displayed in web view
 */
export function GlossaryWeb(props) {
  const { state, onFetchGlossary, onFetchGlossaryItem } =
    React.useContext(GlossaryDispatch);

  const onSearch = (event) => {
    event.preventDefault();
    onFetchGlossary();
  };

  const isGlossaryEmpty = React.useMemo(() => {
    return state.glossaryList.length <= 0;
  }, [state.glossaryList.length]);

  const renderIndexExpanded = () => (
    <div className={style.glossary_left}>
      <div className={style.glossary_left_header}>
        <Glossary.GlossaryLogo />
        <Glossary.SearchBox>
          <LogEvent
            logEventProps={{
              event_type: "sim_id searched",
              event_schema: "sim_id",
              search_term: state.searchText,
            }}
            actionProps={{
              onClick: { action: "click" },
              onEnterKey: { action: "enter" },
            }}
            elementType="button"
          >
            <Glossary.SearchInput
              value={state.searchText}
              onEnterKey={onSearch}
            />
            <Glossary.SearchIcon onClick={onSearch} />
          </LogEvent>
        </Glossary.SearchBox>
        <Glossary.ChevronIcon className={style.glossary_left_chevron} />
      </div>
      <div className={style.glossary_left_middle}>
        <Glossary.CategoryTabs categories={state.categories} />
      </div>
      <div className={style.glossary_left_body}>
        <Glossary.GlossaryListBlock
          {...state.listApi}
          onRetry={onSearch}
          isEmpty={isGlossaryEmpty}
        >
          <Glossary.GlossaryListing glossaryList={state.glossaryList} />
        </Glossary.GlossaryListBlock>
      </div>
    </div>
  );

  const renderIndexCollapsed = () => (
    <div className={style.glossary_left__collapsed}>
      <Glossary.IndexCollapsed />
    </div>
  );

  const renderIndex = () =>
    state.indexCollapsed ? renderIndexCollapsed() : renderIndexExpanded();

  return (
    <div className={style.glossary}>
      {renderIndex()}
      <div className={style.glossary_right}>
        <LogEvent
          logEventProps={{
            event_type: "sim_id clicked",
            event_schema: "sim_id",
          }}
          actionProps={{ close: { action: "close" } }}
          elementType="button"
        >
          <CloseButton
            close={props.closeGlossary}
            className={style.glossary_right_closeButton}
          />
        </LogEvent>

        <Glossary.DetailsBlock
          {...state.contentApi}
          onRetry={() => onFetchGlossaryItem(state.selected)}
        >
          <Glossary.GlossaryDetails {...state.glossaryItem} />
        </Glossary.DetailsBlock>
      </div>
    </div>
  );
}

GlossaryWeb.propsTypes = {
  /**
   * function to close glossary modal window
   */
  closeGlossary: PropsTypes.func,
};
